import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

export function LiberisToPayproTerms() {
  const { t } = useTranslation();

  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        {t(
          'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.liberisDataToPayPro.title',
        )}
      </Typography>
      <Typography>
        {t(
          'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.liberisDataToPayPro.content',
        )}
      </Typography>
    </Stack>
  );
}
